<template>
  <v-modal id="modal-preview" :is-big="true" :modal="false">
    <span slot="header">Preview</span>
    <spinner :visible="isLoading"></spinner>
    <p v-if="error">{{ i18nJS.errors.critical_error }}</p>
    <div v-if="!isLoading && !error" id="preview" class="full-width">
      <iframe :src="srcData" width="100%" height="100%"></iframe>
    </div>
    <!--input slot="footer" type="button" value="Scarica" class="btn btn-success js-form-validate-submit-btn" /-->
  </v-modal>
</template>

<script>
import vModal from '../vModal';
import apiConnector from '@/epersonam/apiConnector';
import spinner from '../spinner';

export default {
  name: 'Preview',
  components: {
    vModal,
    spinner,
  },
  props: {
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  data: function () {
    return {
      isLoading: true,
      srcData: null,
      pdfObjectUrl: null,
      error: false,
    };
  },
  mounted() {
    eventBus.$on('openPreview', () => {
      this.srcData = null;
      $('#modal-preview').modal('show');
      apiConnector()
        .get(this.url)
        .then(({ data }) => {
          if (data) {
            this.clearPdfPreview();
            const byteCharacters = atob(data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const pdfBlob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' });
            this.pdfObjectUrl = URL.createObjectURL(pdfBlob);
            this.srcData = this.pdfObjectUrl;
          }
        })
        .catch((err) => {
          console.error('Error on download from gipo', err);
          this.error = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    });
  },
  beforeDestroy() {
    this.clearPdfPreview();
  },
  methods: {
    clearPdfPreview() {
      if (this.pdfObjectUrl) {
        URL.revokeObjectURL(this.pdfObjectUrl);
        this.pdfObjectUrl = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#preview {
  iframe {
    min-height: 100vh;
  }
}
</style>
